<template>
  <div class="stream-video">
    <video-player ref="videoPlayer"
                  class="video-player vjs-custom-skin"
                  :playsinline="true"
                  :options="playerOptions"
                  Start
                  State
                  pause />
  </div>
</template>

<script>
export default {
  name: 'StreamVideo',
  props: ['hls_stream_url'],
  data() {
    return {
      playerOptions: {
        // Playback Rates: [0.7, 1.0, 1.5, 2.0], // Play Speed
        autoplay: false, // If true, the browser starts playback when it's ready.
        muted: false, // Any audio will be removed by default.
        loop: false, // Cause the video to start again as soon as it's over.
        preload: 'auto', // It is suggested that browsers should start downloading video data after loading elements in <video>. auto browser chooses the best behavior and immediately starts loading videos (if browser supports it)
        language: 'tr-TR',
        aspectRatio: '16:9', // Place the player in fluent mode and use this value when calculating the dynamic size of the player. Values should represent a ratio - two numbers separated by colons (e.g. "16:9" or "4:3")
        fluid: true, // When true, Video.js player will have the fluid size. In other words, it will scale to suit its container.
        sources: [
          // {
          //   type: 'video/mp4',
          //   src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          // },
          // {
          //   type: 'application/x-mpegURL', // There are many kinds of support here: basic video format, live broadcast, streaming media, etc. See git Web site Project specifically.
          //   src: 'https://austchannel-live.akamaized.net/hls/live/2002736/austchannel-sport/master.m3u8', //url address, from the point of view of other bloggers, can be personally tested.
          // },
        ],
        hls: true,
        //poster: 'http://pic33.nipic.com/20131007/13639685_123501617185_2.jpg', //your cover address
        width: document.documentElement.clientWidth, // Player width
        notSupportedMessage:
          'This video cannot be played for the time being. Please try again later.', // Allows overwriting of default information displayed when Video.js cannot play the media source.
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // Full screen button
        },
      },
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player //Custom Play
    },
  },
  mounted() {
    this.playVideo()
  },
  methods: {
    playVideo: function () {
      const video = {
        withCredentials: false,
        type: 'application/x-mpegURL',
        src: this.hls_stream_url,
      }
      this.player.reset() // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
      this.player.src(video)
      // this.player.load()
      this.player.play()
    },
  },
  watch: {
    hls_stream_url() {
      this.playVideo()
    },
  },
}
</script>